<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header bg-info">
        <h5>Поиск</h5>
      </div>
      <div class="card-body">
        Поиск препарата
        <DrugSearchNew
          :onSelect="newSelectedDrug"
        />
      </div>
    </div>
    <template v-if="selectedDrug && selectedDrug.id">
      <EditDrugBlock
        ref="EditDrugBlock"
        :selectedDrug="selectedDrug"
      />
    </template>
  </div>
</template>

<script>

import api from "@/api"
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import EditDrugBlock from './components/EditDrugBlock';

export default {
  components: {
    DrugSearchNew,
    EditDrugBlock,
  },
  data() {
    return {
      selectedDrug: {},
    }
  },
  mounted() {
    // this.initNewDrug();
    if (this.$route.params && this.$route.params.id) {
      this.selectedDrug = {id: this.$route.params.id}
      // this.getDrug();
    }
  },
  methods: {
    newSelectedDrug(drug) {
      this.selectedDrug = null;
      console.log(drug);
      if (!drug) return;
      this.selectedDrug = drug;
      // this.$refs.EditDrugBlock.getDrug();
      // this.getDrug();
    },
  }
}

</script>

<style scoped>
.card {
  margin-bottom: 5px;
}

textarea {
  font-size: 13px;
}

.registration_type_select {
  width: 250px;
}
</style>
